import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { InputNumber } from "primereact/inputnumber";

import { systemCurrencies } from "../../../Utils/Utils";

import commonStyle from "../../content/CommonStyles.module.css";

const CurrencyAmountInput = ({amount, currency, onCurrencyChange, onAmountChange, label="Ціна", customStyle="", errors, touched, mandatory, currencyDisabled}) => {
    return (
        <div className={`${commonStyle.formInput} ${customStyle}`}>
            <div className="p-inputgroup py-0 flex-1">
                <FloatLabel>
                    <span className={`${commonStyle.currencySpan} p-inputgroup-addon`}>
                        <Dropdown
                            value={currency}
                            onChange={e => onCurrencyChange(e.value)}
                            disabled={currencyDisabled}
                            options={systemCurrencies} />
                    </span>
                    <InputNumber
                        name="price"
                        value={amount}
                        onChange={e => onAmountChange(e.value)}
                        minFractionDigits={2}
                        maxFractionDigits={2}
                        className={errors && touched ? 'p-invalid' : ''}
                    />
                    <label>{label}{mandatory && <span className={commonStyle.requiredAsterisk}>*</span>}</label>
                </FloatLabel>
            </div>
            {errors && touched && (<small className={commonStyle.errorSmall}>{errors}</small>)}
        </div>
    );
}

export default CurrencyAmountInput